import { create } from 'zustand';
import { AuthStore } from './authStore';
import { persist } from 'zustand/middleware';
import { useChatStore } from '../chat/use-chat-store';
import { useModelStore } from '../chat/use-model-store';
import { useCommonStore } from '../common/useCommonStore';
import posthog from 'analytics/posthogClient';

export const useAuthStore = create<AuthStore>()(
  persist(
    (set) => ({
      isAuthenticated: false,
      isMfaEnabled: false,
      accessToken: null,
      refreshToken: null,
      login: (accessToken, refreshToken) =>
        set({
          isAuthenticated: true,
          isMfaEnabled: true,
          accessToken,
          refreshToken,
        }),
      setAccessToken: (accessToken) =>
        set({
          accessToken,
        }),
      logout: () => {
        // Clear auth state
        try {
          posthog.reset();
        } catch (error) {
          console.log('Failed to reset PostHog:', error);
        }
        useChatStore.getState().reset();
        useModelStore.getState().reset();
        useCommonStore.getState().reset();

        set({
          isAuthenticated: false,
          isMfaEnabled: false,
          accessToken: null,
          refreshToken: null,
        });

        // Clear subscription state (import done dynamically to avoid circular deps)
        import('../subscription').then(({ useSubscriptionStore }) => {
          useSubscriptionStore.getState().clearSubscription();
        });
      },
    }),
    {
      name: 'auth-storage',
    }
  )
);
